module.exports = __webpack_public_path__ + "media/images/pc/articles/recommend_03-bfb0d68e0bd31f18eda4533cb5515622.webp";